import api from '../api';

const authHeaders = (accessToken) => ({
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
});

const notificationRequest = {
    skipAuthRecovery: true,
};

export default {
    async getDataNotifications(accessToken) {
        try {
            console.log('Fazendo requisição para /portal/notification com token:', accessToken ? 'disponível' : 'não disponível');
            const response = await api.get(`/portal/notification`, {
                headers: authHeaders(accessToken),
                ...notificationRequest,
            });
            console.log('Resposta bruta da API:', response);
            console.log('Dados da resposta:', response.data);
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error('Erro ao carregar as notificações:', error);
            throw error;
        }
    },
    async getNumberNotifications(accessToken) {
        try {
            const response = await api.get(`/portal/notification/total-unread`, {
                headers: authHeaders(accessToken),
                ...notificationRequest,
            });
            return typeof response.data === 'number' ? response.data : 0;
        } catch (error) {
            console.error('Erro ao carregar quatidade de notificações:', error);
            return 0;
        }
    },
    async readNotification(accessToken, payload) {
        try {
            const response = await api.post(`/portal/notificationuser`, payload, {
                headers: authHeaders(accessToken),
                ...notificationRequest,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao marcar notificação como lida:', error);
            throw error;
        }
    }

}
